import {defineMessages} from 'react-intl';

export default defineMessages({
	notifyMeError: {
		id: 'common.error.general',
		defaultMessage: 'Oops! Something went wrong.'
	},
	notifyMeSuccess: {
		id: 'popups.notifyMe.success',
		defaultMessage: 'Thanks, your request has been saved.'
	},
	quantityError: {
		id: 'productView.button.quantityError',
		defaultMessage: 'You have entered the maximum quantity available for this item'
	}
});